import { cva } from '@/styled-system/css';

export const upsellRootRecipe = cva({
  base: {
    display: 'flex',
    rowGap: 'default',
    columnGap: 'default',
    borderRadius: 'obj.default',
    borderWidth: 'default',
    borderStyle: 'solid',
    paddingBlock: 'default',
    paddingInline: 'default',
    position: 'relative',
  },
  variants: {
    tone: {
      neutral: {
        backgroundColor: 'bg.neutral',
        borderColor: 'Upsell.Root.neutral.border',
      },
      soft: {
        backgroundColor: 'Upsell.Root.soft.bg',
        borderColor: 'border.invisible',
      },
      hero: {
        backgroundColor: 'Upsell.Root.hero.bg',
        borderColor: 'border.invisible',
      },
      impact: {
        backgroundColor: 'bg.express.trust.impact',
        borderColor: 'border.invisible',
      },
    },
    elevated: {
      true: {
        boxShadow: 'Upsell.Root',
      },
      false: {},
    },
  },
  compoundVariants: [
    {
      tone: 'neutral',
      elevated: true,
      css: {
        backgroundColor: 'Upsell.Root.neutral.elevated.bg',
        borderColor: 'Upsell.Root.neutral.elevated.border',
      },
    },
  ],
});
